import { createAsyncThunk } from '@reduxjs/toolkit'
import TargetGroup from './target-group-model'
import {
  delete_targetGroup,
  load_targetGroups,
  store_targetGroup,
} from './targetGroup-service'

export const LoadTargetGroupsAsync = createAsyncThunk<any, any>(
  'composer/load/targetGroup',
  async (params: { uid: string }) => {
    return await load_targetGroups(params)
  },
)

export const CreateTargetGroupAsync = createAsyncThunk<any, any>(
  'composer/create/targetGroup',
  async (params: TargetGroup) => {
    return await store_targetGroup(params)
  },
)

export const DeleteTargetGroupAsync = createAsyncThunk<any, any>(
  'composer/delete/targetGroup',
  async (params) => {
    return await delete_targetGroup(params)
  },
)
